<script setup lang="ts">
import descIcon from '@/assets/icons/desc.svg';
import ascIcon from '@/assets/icons/asc.svg';
import noneIcon from '@/assets/icons/none.svg';
import { computed } from 'vue'

interface Props {
  field: string,
  dir: string | boolean,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const _dir = computed(() => props.dir)

const emit = defineEmits(['update:sort'])

const handleChangeDirection = (direction: string): void => {
  let _direction: string;
  switch (direction) {
    case 'asc': _direction = 'desc'; break;
    case 'desc': _direction = ''; break;
    default: _direction = 'asc'; break;
  }
  emit('update:sort', props.field, _direction)
}
</script>

<template>
  <div class="sort-icon" v-if="_dir !== false">
    <img :src="descIcon" alt="" v-if="_dir === 'desc'" @click="()=>handleChangeDirection('desc')"/>
    <img :src="ascIcon" alt="" v-if="_dir === 'asc'" @click="()=>handleChangeDirection('asc')"/>
    <img :src="noneIcon" alt="" v-if="_dir === ''" @click="()=>handleChangeDirection('')"/>
  </div>
</template>

<style scoped>

</style>
